import React, { useContext } from 'react';
import { ValidateCodeRequestResponse } from 'api/authenticationApi';

export interface Store {
  state?: ValidateCodeRequestResponse | undefined;
  setState?: any;
  isCustomer: boolean | null;
  setIsCustomer: any;
  isMerchant: boolean | null;
  setIsMerchant: any;
  hasSettingsPermission: boolean | null;
  setHasSettingsPermission: any;
  hasOperationsPermission: boolean | null;
  setHasOperationsPermission: any;
  hasSuperAdminPermission: boolean | null;
  setHasSuperAdminPermission: any;
  hasViewOnlyPermission: boolean | null;
  setHasViewOnlyPermission: any;
}

const store: Store = {
  state: undefined,
  setState: () => {},
  isCustomer: null,
  setIsCustomer: () => {},
  isMerchant: null,
  setIsMerchant: () => {},
  hasSettingsPermission: null,
  setHasSettingsPermission: () => {},
  hasOperationsPermission: null,
  setHasOperationsPermission: () => {},
  hasSuperAdminPermission: null,
  setHasSuperAdminPermission: () => {},
  hasViewOnlyPermission: null,
  setHasViewOnlyPermission: () => {},
};

const AuthContext = React.createContext(store);
AuthContext.displayName = 'Merchant Auth Context';
export const useAuthContext = () => useContext(AuthContext);
export default AuthContext;
